// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpProposLi extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_propos_li";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpProposLi {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Propòsits d'Interès Legítim",
                "cz": "Účel oprávněného zájmu",
                "da": "Legitime interesser",
                "de": "Ziele des legitimen Interesses",
                "en": "Legitimate Interest Purposes",
                "eu-ES": "Interes legitimoaren xedeak",
                "fi": "Laillisen edun tarkoitukset",
                "fr": "Finalités d\\'intérêts légitimes",
                "ga-ES": "Propósitos de interese lexítimo",
                "hi": "वैध हित प्रयोजन",
                "hu": "Jogos érdekek",
                "it": "Propositi di Interesse Legittimo",
                "nl": "Doeleinden van legitiem belang",
                "no": "Legitime formål",
                "pl": "Cele związane z uzasadnionym interesem",
                "pt": "Objetivos de Interesse Legítimo",
                "pt-BR": "Objetivos de interesse legítimos",
                "ro": "Scopuri de interés legitim",
                "ru": "Согласия на законное использование",
                "sv": "Legitima intresseändamål",
                "sk": "Účel oprávneného záujmu"
            },
            "defecto": "Propósitos de Interés Legítimo"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
